/* eslint-disable @typescript-eslint/naming-convention */
import { z } from 'zod';

export interface AddressValidationOptions {
    streetMaxLength?: number;
}

export const createAddressSchema = (options?: AddressValidationOptions) => {
    let streetField = z
        .string({ required_error: 'Enter your street address' })
        .trim()
        .min(1, { message: 'Enter your street address' });

    if (options?.streetMaxLength !== undefined) {
        streetField = streetField.max(options.streetMaxLength, {
            message: `Street address must be ${options.streetMaxLength} characters or less`,
        });
    }

    return z.object({
        street: streetField,
        address2: z.string({ required_error: 'Enter your apartment or suite number' }).optional(),
        city: z
            .string({ required_error: 'Enter your city' })
            .trim()
            .min(1, { message: 'Enter your city' }),
        state: z
            .string({ required_error: 'Select a state', invalid_type_error: 'Select a state' })
            .min(1, { message: 'Select a state' }),
        zip: z
            .string({ required_error: 'Enter your zip code' })
            .regex(/^\d{5}$/, { message: 'Enter a valid zip code' }),
    });
};

export const addressSchema = createAddressSchema();
